<script setup lang="ts">
import {useUserStore} from "~/stores/user";

const {userData} = useUserStore()
</script>

<template>
  <AtomsMessageBanner v-for="banner in userData.banners" :key="banner.type" :banner="banner" />
</template>